// extracted by mini-css-extract-plugin
module.exports = {"resultsAction":"search-results-action-wrapper_resultsAction__rNuFG","resultsActionLabel":"search-results-action-wrapper_resultsActionLabel__Ug_R7"};